import {Field, FieldProps, Form, Formik, FormikProps} from 'formik';
import React, {forwardRef, memo} from 'react';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';

import {Patient} from '../../interfaces/entities/patient.interface';
import {MultiLinesField} from './shared/multi-lines-field.component';

type PatientMusic = Pick<Patient, 'music'>;

interface PatientMusicFormProps extends PatientMusic {
  onChange: (data: PatientMusic) => void;
}

const MIN_ROWS = 5;

function PatientMusicFormBase({onChange, ...props}: PatientMusicFormProps, ref: React.Ref<FormikProps<Patient>>) {
  const {t} = useTranslation();

  return (
    <Formik<PatientMusic>
      initialValues={props || {}}
      onSubmit={onChange}
      innerRef={ref as React.Ref<FormikProps<PatientMusic>>}
      validationSchema={Yup.object<Record<keyof PatientMusic, Yup.AnySchema>>().shape({
        music: Yup.string().nullable().optional(),
      })}
    >
      {() => (
        <Form>
          <Field name="music">
            {(props: FieldProps) => {
              return (
                <MultiLinesField
                  {...props}
                  label={t('patient-edit-music.label')}
                  assistiveText={t('patient-edit-music.assistive')}
                  assistiveTextPosition={'top'}
                  minRows={MIN_ROWS}
                />
              );
            }}
          </Field>
        </Form>
      )}
    </Formik>
  );
}

export const PatientMusicForm = memo(forwardRef(PatientMusicFormBase));
